import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';

import { coreRoutes } from '@next/core-lib/app';
import { LocationGuard } from '@next/core-lib/relationships';
import { Observable } from 'rxjs';

import { CycleComponent } from './cycle/cycle.component';
import { cycleRoutes } from './cycle/cycle.routes';
import { CyclesGuard } from './cycle/guards/cycles.guard';
import { DeliveryRouterComponent } from './delivery/components/delivery-router/delivery-router.component';
import { deliveryRoutes } from './delivery/delivery.routes';
import { PerformanceOverviewComponent } from './performance/components/performance-overview/performance-overview.component';
import { PerformanceResolver } from './performance/resolvers/performance.resolver';
import { ReferenceValueSheetRouterComponent } from './reference-value-sheet/components/reference-value-sheet-router/reference-value-sheet-router.component';
import { referenceValueSheetRoutes } from './reference-value-sheet/reference-value-sheet.routes';
import { SettingsOverviewComponent } from './settings/components/settings-overview/settings-overview.component';
import { settingsRoutes } from './settings/settings.routes';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';

export const appRoutes: Routes = [
  { path: '', redirectTo: 'cycle', pathMatch: 'full' },
  {
    path: 'cycle',
    component: CycleComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    children: cycleRoutes,
  },
  {
    path: 'delivery',
    component: DeliveryRouterComponent,
    children: deliveryRoutes,
  },
  {
    path: 'performance',
    component: PerformanceOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard, CyclesGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(PerformanceResolver),
    },
  },
  {
    path: 'reference-value-sheet',
    component: ReferenceValueSheetRouterComponent,
    children: referenceValueSheetRoutes,
  },
  {
    path: 'settings',
    component: SettingsOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    children: [{ path: '', redirectTo: 'barn', pathMatch: 'full' }, ...settingsRoutes],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  ...coreRoutes,
];
